
<template>
  <v-dialog v-model="show" persistent content-class="dialog--alert" :max-width="width">
    <v-card>
      <v-card-title class="title--dialog title"><v-icon size="20" color="warning">warning</v-icon> Confirmar</v-card-title>
      <v-card-text v-html="text" class="pt-0"></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="textCancel!=''" @click.native="cancel()" id="btn-confirm-selected-cancel">{{ textCancel }}</v-btn>
        <v-btn color="primary" @click.native="ok()" id="btn-confirm-selected-ok">{{ textOk }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
  mounted () {
    const el = document.querySelector('.dialog--alert');
    if (el) {
      el.parentNode.style.zIndex = 100;
    }
  },
  methods: {
    ok () {
      const { confirm } = this.$store.state;
      confirm.show = false;
      this.$store.commit('CLOSE_CONFIRM');

      if (typeof confirm.callbackOk === 'function') {
        confirm.callbackOk();
      }
    },
    cancel () {
      const { confirm } = this.$store.state;
      confirm.show = false;
      this.$store.commit('CLOSE_CONFIRM');

      if (typeof confirm.callbackCancel === 'function') {
        confirm.callbackCancel();
      }
    }
  },
  computed: mapState({
    show: store => store.confirm.show,
    width: store => store.confirm.width,
    text: store => store.confirm.text,
    textOk: store => store.confirm.textOk,
    textCancel: store => store.confirm.textCancel
  })
};
</script>




// WEBPACK FOOTER //
// src/common/plugins/Modal/Confirm.vue